import "@/App.css";
import PitchDeck from "@/components/PitchDeck";

function App() {
  return (
    <div className="App">
      <PitchDeck />
    </div>
  );
}

export default App;
